import { isDefined } from './is-defined.js';

const resolveColorsPalette = (args) => {
  return [...args.colors, args.currentColor].filter(isNotEmpty).map(toUpperCase).filter(isNotDuplicate).slice(-12);
};
const isNotEmpty = (c) => isDefined(c) && c !== "";
const toUpperCase = (c) => c.toUpperCase();
const isNotDuplicate = (item, index, itemArray) => itemArray.indexOf(item) === index;

export { resolveColorsPalette };
//# sourceMappingURL=resolveColorsPalette.js.map
